import { cn } from "@/lib/utils";
import { TrendingUp, TrendingDown } from "lucide-react";

const TONE_CLASS = {
  success: "text-emerald-500 dark:text-emerald-400",
  danger: "text-primary",
};

// Large, elegant KPI: big number dominates, label below. Not a colorful card grid.
// `accent` is the plain "highlight this number" boolean (always the brand/
// danger color). `tone` is for when the color itself needs to depend on the
// value (e.g. green at zero, red once something needs attention) — pass one
// or the other, not both.
export function KPICard({ label, value, delta, deltaDir, icon: Icon, accent, tone, className, testId }) {
  return (
    <div
      data-testid={testId}
      className={cn(
        "group relative overflow-hidden rounded-2xl border border-border/70 bg-card/60 p-5 transition-all duration-300 hover:border-border hover:bg-card",
        className
      )}
    >
      <div className="flex items-start justify-between">
        <div className="flex flex-col">
          <span className={cn("font-display text-4xl font-semibold tracking-tight tabular-nums leading-none", tone ? TONE_CLASS[tone] : accent && "text-primary")}>
            {value}
          </span>
          <span className="mt-2 text-xs uppercase tracking-wider text-muted-foreground">{label}</span>
        </div>
        {Icon && (
          <div className="rounded-xl border border-border/60 bg-secondary/40 p-2 text-muted-foreground transition-colors group-hover:text-foreground">
            <Icon className="h-4 w-4" />
          </div>
        )}
      </div>
      {delta != null && (
        <div className={cn("mt-3 inline-flex items-center gap-1 text-xs font-medium", deltaDir === "down" ? "text-red-400" : "text-emerald-400")}>
          {deltaDir === "down" ? <TrendingDown className="h-3.5 w-3.5" /> : <TrendingUp className="h-3.5 w-3.5" />}
          {delta}
        </div>
      )}
    </div>
  );
}
